<script>
import PageFooter from '@/components/misc/PageFooter.vue';

export default {
  components: { PageFooter },
  name: 'GenericErrorPage',
  props: {
    errorCode: {
      type: [String, Number],
      default: 'Oops!',
    },
    title: {
      type: String,
      default: 'Something Went Astray',
    },
    message: {
      type: String,
      default: 'The stars misaligned, or perhaps this page ventured into an uncharted realm. Let\'s guide you back to familiar paths.',
    },
    showGoHomeButton: {
      type: Boolean,
      default: true,
    },
  },
  head() {
    // Use the title prop if available and not 'Oops!', otherwise default to 'Error' or 'Page Not Found'
    const pageTitle = (this.title && this.title !== 'Something Went Astray') ? this.title : 
                      (this.errorCode === '404' ? this.$t('pageTitles.pageNotFound') : this.$t('common.labels.error'));
    return { title: pageTitle };
  },
  computed: {
    displayErrorCode() {
      // Prepend "Error " if it's a numeric code like 404, 500
      if (!isNaN(Number(this.errorCode))) {
        return `Error ${this.errorCode}`;
      }
      return this.errorCode;
    }
  }
};
</script>

<template>
  <div class="auth-page-wrapper pt-5">
    <!-- Background elements -->
    <router-link to="/">
      <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div class="bg-overlay"></div>
        <div class="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>
        </div>
      </div>
    </router-link>

    <!-- Page Content -->
    <div class="auth-page-content">
      <BContainer>
        <BRow class="justify-content-center error-page-row">
          <BCol md="10" lg="8" xl="7"> 
            <BCard no-body class="mt-4">
              <BCardBody class="p-4 text-center">
                <div class="avatar-lg mx-auto mt-2">
                    <div class="avatar-title bg-light text-secondary display-3 rounded-circle">
                        <i class="ri-ghost-smile-line"></i>
                    </div>
                </div>
                <div class="mt-4 pt-2">
                    <h4>{{ title }}</h4>
                    <p class="text-muted fs-15">{{ displayErrorCode }}</p>
                    <p class="text-muted mb-4 fs-15">{{ message }}</p>
                    <router-link v-if="showGoHomeButton" to="/" class="btn btn-secondary">
                      <i class="mdi mdi-home me-1"></i>{{ $t('errorsPage.buttons.backToHome') }}
                    </router-link>
                </div>
              </BCardBody>
            </BCard>
          </BCol>
        </BRow>
      </BContainer>
    </div>

    <PageFooter />
  </div>
</template>

<style scoped>
.error-page-row {
  margin-top: 150px; /* Default margin for mobile */
}

/* Apply larger margin for medium screens and up (Bootstrap's 'md' breakpoint is 768px) */
@media (min-width: 768px) {
  .error-page-row {
    margin-top: 250px;
  }
}

.auth-page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.auth-page-content {
  flex-grow: 1;
}

.card-body {
    padding: 2.5rem !important; /* More padding for error content */
}
</style>